/**
 * ga4-events.js
 *
 * GA4 enhanced ecommerce event tracking for CraftyQ.
 *
 * Handles:
 *  - add_to_cart    → via PUB_SUB_EVENTS.cartUpdate (pubsub.js / product-form.js)
 *  - begin_checkout → via click on any checkout link or button
 *
 * view_item and view_item_list are fired from inline <script> blocks in:
 *   sections/main-product.liquid
 *   sections/main-collection-product-grid.liquid
 *
 * The purchase event must be configured in:
 *   Shopify Admin > Settings > Checkout > Order processing > Additional scripts
 * (The thank-you page is outside the theme on standard Shopify plans.)
 */
(function () {
  'use strict';

  // Only run when GA4 has been initialised by analytics-gtag.liquid
  if (typeof window.ga4MeasurementId === 'undefined' || typeof gtag === 'undefined') return;

  // ── add_to_cart ──────────────────────────────────────────────────────────────
  // Subscribe to Shopify's pubsub cart-update event published by product-form.js
  // after a successful /cart/add.js response.
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Only handle adds from the product form (not quantity-update changes)
      if (event.source !== 'product-form') return;

      var variantId = parseInt(event.productVariantId, 10);
      var cartData  = event.cartData;
      if (!cartData || !cartData.items) return;

      // Find the matching line item in the returned cart response
      var item = cartData.items.find(function (i) { return i.id === variantId; });
      if (!item) return;

      gtag('event', 'add_to_cart', {
        currency: cartData.currency,
        value:    parseFloat((item.price / 100).toFixed(2)),
        items: [{
          item_id:      String(item.product_id),
          item_name:    item.product_title,
          item_variant: item.variant_title || undefined,
          item_brand:   item.vendor        || undefined,
          price:        parseFloat((item.price / 100).toFixed(2)),
          quantity:     1
        }]
      });
    });
  }

  // ── begin_checkout ───────────────────────────────────────────────────────────
  // Capture clicks on checkout links/buttons and fire begin_checkout with
  // the current cart contents fetched asynchronously.
  document.addEventListener('click', function (e) {
    var target = e.target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
    );
    if (!target) return;

    // Fetch current cart state to build the items array for GA4
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;

        gtag('event', 'begin_checkout', {
          currency: cart.currency,
          value:    parseFloat((cart.total_price / 100).toFixed(2)),
          items: cart.items.map(function (item) {
            return {
              item_id:      String(item.product_id),
              item_name:    item.product_title,
              item_variant: item.variant_title || undefined,
              item_brand:   item.vendor        || undefined,
              price:        parseFloat((item.price / 100).toFixed(2)),
              quantity:     item.quantity
            };
          })
        });
      })
      .catch(function () {
        // Silently ignore — must not block the checkout navigation
      });
  });

})();
